import styled from "@emotion/styled";

import { transientOptions } from "shared/lib/styles";

import { HamburgerMenuSubscriberInstruction } from "scmp-app/components/hamburger-menu/hamburger-menu-default/hamburger-menu-subscriber-instruction";
import { HamburgerMenuSearchArea } from "scmp-app/components/hamburger-menu/hamburger-menu-default/hamburger-non-search-area";
export const Container = styled.div`
  position: relative;

  display: flex;

  min-block-size: 41px;
  margin-block-end: 32px;
`;

type HamburgerMenuSubscriberInstructionProps = {
  $isShow: boolean;
};

export const StyledHamburgerMenuSubscriberInstruction = styled(HamburgerMenuSubscriberInstruction, {
  ...transientOptions,
})<HamburgerMenuSubscriberInstructionProps>`
  opacity: ${props => (props.$isShow ? 1 : 0)};

  transition: opacity 0.2s ease-in-out;
`;

type HamburgerMenuSearchAreaProps = {
  $isExpanded: boolean;
};
export const StyledHamburgerMenuSearchArea = styled(HamburgerMenuSearchArea, {
  ...transientOptions,
})<HamburgerMenuSearchAreaProps>`
  position: absolute;
  inset-inline-end: 0%;

  inline-size: ${props => (props.$isExpanded ? `100%` : "auto")};
`;
